import * as accountsApi from '@/network/api/accounts.api.js'
import * as apiEmis from '@/network/api/payments/emis.api.js'

/** requests Accounts Balance
@return { promise } - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await accountsApi.requestAccountsBalances(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_BALANCE', data)
    }
    return res
}

/** requests Product list for Emis Special
@return { promise } - Product list for Emis Special
*/
export const requestEmisSpecialProductsList = async (context, payload) => {
    const res = await apiEmis.getEmisSpecialProductsList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_EMIS_SPECIAL_PRODUCTS_LIST', data)
    }
    return res
}

/** requests Product Values list for Emis Special
@return { promise } - Product Values list for Emis Special
*/
export const requestEmisSpecialProductsValuesList = async (context, payload) => {
    const res = await apiEmis.getEmisSpecialProductsValuesList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_EMIS_SPECIAL_PRODUCTS_VALUES_LIST', data)
    }
    return res
}

/** Pay Emis Special
@return { promise }
*/
export const payEmisSpecial = async (context, payload) => {
    const res = await apiEmis.payEmisSpecial(payload)
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
/** Clear states
@return { promise }
*/
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
